<template lang="html">
  <v-container
    grid-list-lg
    my-8
    fluid
  >
    <v-layout wrap>
      <v-flex
        v-bind="_pageLayout"
        mx-auto
      >
        <v-layout wrap>
          <v-flex
            xs12
            mb-4
            class="display-2 font-weight-light"
          >
            Announcement
          </v-flex>
          <!-- <v-flex class="font-italic">No active announcements </v-flex> -->

          <v-flex
            xs12
            class="font-weight-bold"
          >
            Date: 14-Jan-2021
          </v-flex>
          <v-flex xs12>
            <p>We have become aware of a telemarketing campaign for a financial advice referral service operated by Information Support Australia Pty Ltd (ABN 66 644 605 363) trading as "Super Information Team”.</p>
            <p>During the call, or voice message left by the caller, telemarketers have identified themselves as being part of the “Super Information Team”. </p>
            <p>We confirm that Super Info <b>is not</b> in any way affiliated with this telemarketing campaign, Information Support Australia Pty Ltd, or “Super Information Team”.</p>
            <p>
              Your privacy is important to us and we do not participate in cold call marketing campaigns. We do not share any of your information outside of Super Info and our delivery partners used solely to deliver our services. See our <router-link to="/privacy">
                privacy statement
              </router-link> for more information.
            </p>
            <p>We recommend that you remain vigilant about the risks of providing personal information to third parties, especially in response to unsolicited telephone calls, emails, text messages or social media contacts.</p>
            <p>
              Should you receive any unsolicited contact claiming to be from Super Info, please report this to us on <a href="tel:1300362400">1300 362 400</a> or via our <router-link to="/contact">
                contact page
              </router-link>.
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import renderReady from '@/mixins/render-ready'


export default {
  mixins: [ renderReady ],
  computed: {
    ...mapGetters(['_pageLayout'])
  }
}
</script>

<style lang="css" scoped>

</style>
